import { Typography, Box, useTheme } from "@mui/material";
import { tokens } from '@/utilities';

interface Props{
    title: string
    subtitle: string
}

const Header = ({ title, subtitle }: Props) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  return (
    <Box mb="30px">
      <Typography
        variant="h2"
        color={colors.grey[100]}
        fontWeight="bold"
        sx={{ m: "0 0 5px 0"}}
      >
        {title}
      </Typography>
      <Typography variant="h5" sx={{color:colors.grey[100]}}>
        {subtitle}
      </Typography>
    </Box>
  );
};

export default Header;